export const STAFF_AUGMENTATION_URL =
  "https://ultroneous.com/it-staff-augmentation-services";
export const STAFF_AUGMENTATION_DETAIL =
  "ultroNeous Technologies is a leading IT Staff Augmentation company Use our IT augmentation services. We help clients get quick access to a skilled pool of tech talent.";
export const STAFF_AUGMENTATION_TITLE =
  "IT Staff Augmentation Services | ultroNeous Technologies";

export const STAFF_AUGMENTATION_FAQS_DATA = [
  {
    question: " What kind of staff augmentation service will you do?",
    answer:
      'We will be able to supply you with resources for UI/ UX designing, custom software development, front end development, backend development, mobile app development, <a href="/digital-marketing-services">digital marketing </a> and any other type of resources you are seeking for. Kindly go through our technologies page to find more details.',
  },
  {
    question: "How can I share my requirements with you?",
    answer:
      "If you have a clear job description and resource parameters defined then you can share it with our IT staff augmentation team via email. If you do not have any idea about what you need in a team then just talk with our business team and they will guide  you.",
  },
  {
    question: "Will they work with my existing team?",
    answer:
      "Yes, our resources are trained to work with a remote team and clients. They will be working in your existing or new projects as your team member only with direct reporting over your communication channels.",
  },
  {
    question: " Will I be able to take their interview?",
    answer:
      "Yes, you can take the interview or let your end client take their interview under your company’s brand.",
  },
  {
    question: "How many resources do I need to hire?",
    answer:
      "It is up to you. You can hire a single resource or a completely dedicated team consisting of multiple resources to take care of your project.",
  },
  {
    question: "Will your resource directly work with my end client?",
    answer:
      " Yes, our resource will be working as your employee only in front of your client. We follow proper legal processes to save the client as well as resource confidentiality. ",
  },
  {
    question: "Are you an IT staff augmentation company in usa?",
    answer:
      "We are based in India having our business team working in the USA too. The resource would be working remotely, added in the communication channel you prefer and will make sure to follow all the processes defined by you or your client. ",
  },
  {
    question: "What would be the benefit of this business model?",
    answer:
      "We will take care of your recruitment, training, admin and staffing costs. Plus we have a free replacement option available for a resource. All this time and cost consuming processes are taken care of by our team which itself is a huge benefit to you.",
  },
];
export const WHAT_EXPECT_IT_STAFF_DATA = [
  {
    image: "/assets/services/staff-augmentation/correct-resources.webp",
    alt: "Correct set of Resources",
    title: "Correct set of Resources",
    description:
      "With the clear understanding of your resource or a team requirement, our IT staff augmentation services experts will curate the correct set of resources who will start delivering results from the first day.",
  },
  {
    image: "/assets/services/staff-augmentation/agreement-objective.webp",
    alt: "Agreement & Objective",
    title: "Agreements & Objectives",
    description:
      "Here at ultroNeous, In addition to work contracts, we help you setting up OKRs (Objectives and Key Results) and NDAs (Non-Disclosure Agreements) for selected professionals to keep everything secured.",
  },
  {
    image: "/assets/services/staff-augmentation/dedicated-experts.webp",
    alt: "Dedicated Experts",
    title: "Dedicated Experts",
    description:
      "Being an IT staff augmentation company we provide dedicated tech experts, who bring real value to your product and business by optimizing every development aspect so you can easily transform digitally.",
  },
  {
    image: "/assets/services/staff-augmentation/enhanced-productivity.webp",
    alt: "Enhanced Productivity",
    title: "Enhanced Productivity",
    description:
      "As our team focuses solely on your project, their performance productivity increases, and precise communication plans allow clear expression of requirements and the productive execution.",
  },
  {
    image: "/assets/services/staff-augmentation/oversight-control.webp",
    alt: "Ensure Oversight and Control",
    title: "Ensure Oversight and Control",
    description:
      "As part of our staff augmentation process, our engineers become part of your internal workflow, reporting directly to management, and attend regular meetings as well as follow any kind of processes you need. ",
  },
  {
    image: "/assets/services/staff-augmentation/consistent-support.webp",
    alt: "Consistent Support",
    title: "Consistent Support",
    description:
      "Once the hiring procedure is completed, our team provides constant support throughout the project's lifetime to ensure higher engagement and ROI along with a smoother transformation whenever needed.",
  },
];
export const STAFF_AUGMENTATION_SCHEMA = {
  itstaffAugmentationBreadcrumb: {
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        item: {
          "@id": "https://ultroneous.com/",
          name: "ultroNeous Technologies",
        },
      },
      {
        "@type": "ListItem",
        position: 2,
        item: {
          "@type": "WebPage",
          "@id": "https://ultroneous.com/services",
          url: "https://ultroneous.com/services",
          name: "services",
        },
      },
      {
        "@type": "ListItem",
        position: 3,
        item: {
          "@type": "WebPage",
          "@id": STAFF_AUGMENTATION_URL,
          url: STAFF_AUGMENTATION_URL,
          name: "IT Staff Augmentation Services",
        },
      },
    ],
  },
  Faqs_Schema: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What kind of staff augmentation service will you do?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "We will be able to supply you with resources for UI/ UX designing, custom software development, front end development, backend development, mobile app development, digital marketing and any other type of resources you are seeking for. Kindly go through our technologies page to find more details.",
        },
      },
      {
        "@type": "Question",
        name: "How can I share my requirements with you?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "If you have a clear job description and resource parameters defined then you can share it with our IT staff augmentation team via email. If you do not have any idea about what you need in a team then just talk with our business team and they will guide  you.",
        },
      },
      {
        "@type": "Question",
        name: "Will they work with my existing team?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, our resources are trained to work with a remote team and clients. They will be working in your existing or new projects as your team member only with direct reporting over your communication channels.",
        },
      },
      {
        "@type": "Question",
        name: "Will I be able to take their interview?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, you can take the interview or let your end client take their interview under your company’s brand.",
        },
      },
      {
        "@type": "Question",
        name: "How many resources do I need to hire?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "It is up to you. You can hire a single resource or a completely dedicated team consisting of multiple resources to take care of your project.",
        },
      },
      {
        "@type": "Question",
        name: "Will your resource directly work with my end client?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, our resource will be working as your employee only in front of your client. We follow proper legal processes to save the client as well as resource confidentiality.",
        },
      },
      {
        "@type": "Question",
        name: "Are you an IT staff augmentation company in usa?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "We are based in India having our business team working in the USA too. The resource would be working remotely, added in the communication channel you prefer and will make sure to follow all the processes defined by you or your client.",
        },
      },
      {
        "@type": "Question",
        name: "What would be the benefit of this business model?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "We will take care of your recruitment, training, admin and staffing costs. Plus we have a free replacement option available for a resource. All this time and cost consuming processes are taken care of by our team which itself is a huge benefit to you.",
        },
      },
    ],
  },
};
